// Reusable loading spinner component

import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 'medium', message = 'Loading...' }) => {
    return (
        <div className="loading-spinner-container">
            <div className={`loading-spinner ${size}`}>
                <div className="spinner"></div>
            </div>
            {message && <p className="loading-message">{message}</p>}
            <p className="loading-hint" style={{ fontSize: '0.85em', opacity: 0.7, marginTop: '8px' }}>
                💡 If progress appears stuck, don't worry - it's still working in the background
            </p>
        </div>
    );
};

export default LoadingSpinner;
